import { createSlice } from '@reduxjs/toolkit';
import { IFailedPayload } from 'redux/types/Call.types';

export interface DashboardState {
  error: IFailedPayload | null;
  loading: boolean;
  message: string;
}

export const dashboardInitialState: DashboardState = {
  error: null,
  loading: false,
  message: '',
};

const dashboardSlice = createSlice({
  name: 'compliance/dashboard',
  initialState: dashboardInitialState,
  reducers: {
    sayHello: (state) => {
      state.message = 'Hello';
    },
  },
});

export const { sayHello } = dashboardSlice.actions;

export default dashboardSlice.reducer;
